/* TrueSanity wishlist (replaces Swym).
   One heart everywhere: product cards, PDPs, DYOR/DYOP/DYOE setting cards and pages, the builders'
   diamond lists, single diamonds and the "complete your ring" step.
   Items are kept in this browser (localStorage "tsw_v1") and saved to the TrueSanity wishlist service
   (Supabase, project truesanity-storefront, function "wishlist") so a list can be shared and, for
   signed-in customers, follows them to other devices.
   Nothing here creates a Shopify product: a design-your-own piece is saved as its recipe (setting
   variant + diamond) and is built only when the customer adds it to the bag, exactly as the builder does.

   Item kinds:
     product  a Shopify product            key p:<productId>
     setting  a builder setting            key s:<productId>
     dyo      setting + diamond(s)         key d:<kind>:<settingVariantId>:<diamondId>
     diamond  a loose diamond (feed)       key g:<type>:<diamondId>
   Hearts: <button class="tsw-heart" data-tsw-item='{json}'>, or el._tsw = item / function returning item,
   or the old Swym markup (data-swaction="addToWishlist" + data-product-id / data-product-url). */
(function () {
  'use strict';
  if (window.TSW) return;
  var CFG = window.TSW_CFG || {};
  var API = CFG.api || 'https://tghmqkncwbxynkulevgw.supabase.co/functions/v1/wishlist';
  var PAGE = CFG.page || '/pages/wishlist';
  var CUST = CFG.cust && CFG.cust.id ? CFG.cust : null;
  var LS = 'tsw_v1';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + Math.round((+c || 0) / 100).toLocaleString('en-US'); }
  function read() { try { return JSON.parse(localStorage.getItem(LS) || 'null') || {}; } catch (e) { return {}; } }
  function write() { try { localStorage.setItem(LS, JSON.stringify(st)); } catch (e) {} }
  function abs(u) { try { return new URL(u, location.origin).pathname + new URL(u, location.origin).search; } catch (e) { return u || ''; } }

  var st = read();
  if (!Array.isArray(st.items)) st.items = [];
  // signed out (or a different customer) since this browser last saved: the old list stays with that account
  if (st.cid && (!CUST || String(CUST.id) !== String(st.cid))) { st = { items: [] }; write(); }

  /* ---------- store ---------- */
  var subs = [];
  function changed() { write(); paintAll(); subs.forEach(function (f) { try { f(st.items); } catch (e) {} }); }
  function find(key) { for (var i = 0; i < st.items.length; i++) if (st.items[i].key === key) return st.items[i]; return null; }
  function has(key) { return !!find(key); }
  function add(item) {
    if (!item || !item.key) return;
    item.at = Date.now();
    st.items = [item].concat(st.items.filter(function (x) { return x.key !== item.key; })).slice(0, 200);
    changed(); queue();
    track('Added to Wishlist', item);
  }
  function remove(key) { st.items = st.items.filter(function (x) { return x.key !== key; }); changed(); queue(); }
  function update(key, patch) { var it = find(key); if (!it) return; Object.keys(patch).forEach(function (k) { it[k] = patch[k]; }); write(); queue(); }

  /* ---------- server sync (best effort: the list always works from this browser) ---------- */
  var timer = null, inflight = false, dirty = false, ver = 0;
  function post(body) {
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('wishlist ' + r.status); return r.json(); });
  }
  function queue() { dirty = true; ver++; clearTimeout(timer); timer = setTimeout(sync, 700); }
  function sync() {
    if (inflight) { timer = setTimeout(sync, 700); return Promise.resolve(); }
    inflight = true; dirty = false; var sent = ver;
    return post({ op: 'save', token: st.token, items: st.items, cust: CUST || undefined }).then(function (r) {
      st.token = r.token; st.share = r.share;
      if (CUST) st.cid = String(CUST.id);
      // the server's list wins unless the shopper changed something while we were saving
      if (ver === sent && Array.isArray(r.items)) st.items = r.items;
      changed();
    }).catch(function () { /* offline or service down: keep the local list */ })
      .then(function () { inflight = false; if (dirty || ver !== sent) queue(); });
  }
  // signed in on this device for the first time: fold this browser's list into the account's list
  var ready = (CUST && st.cid !== String(CUST.id)) ? sync() : Promise.resolve();

  /* ---------- Klaviyo (onsite embed) ---------- */
  function track(name, it) {
    var k = window.klaviyo || window._learnq;
    if (!k || !k.push) return;
    try { k.push(['track', name, { Kind: it.kind, Title: it.title, Detail: it.sub || '', Price: (it.price || 0) / 100, URL: location.origin + (it.url || ''), ImageURL: it.image || '' }]); } catch (e) {}
  }

  /* ---------- hearts ---------- */
  var SEL = '.tsw-heart, [data-swaction="addToWishlist"]';
  var HEART = '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z"/></svg>';
  function handleOf(u) { var m = String(u || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function itemOf(el) {
    if (typeof el._tsw === 'function') return el._tsw();
    if (el._tsw) return el._tsw;
    if (el.dataset.tswItem) { try { return JSON.parse(el.dataset.tswItem); } catch (e) { return null; } }
    // product hearts (incl. the old Swym markup on cards and PDPs)
    var pid = String(el.dataset.productId || '').replace(/"/g, ''), handle = el.dataset.handle || handleOf(el.dataset.productUrl);
    if (!pid && !handle) return null;
    return { key: 'p:' + (pid || handle), kind: 'product', pid: pid, vid: String(el.dataset.variantId || ''), handle: handle, url: handle ? '/products/' + handle : '' };
  }
  function keyOf(el) { var it = itemOf(el); return it && it.key; }
  function paint(el) {
    if (!el._tswInit) {
      el._tswInit = true;
      el.classList.add('tsw-heart');
      if (el.matches('[data-swaction]')) el.classList.add('tsw-legacy');
      if (!el.querySelector('svg')) el.insertAdjacentHTML('beforeend', HEART);
      if (el.tagName !== 'BUTTON') { el.setAttribute('role', 'button'); el.tabIndex = 0; }
    }
    var k = keyOf(el), on = !!(k && has(k));
    el.classList.toggle('is-saved', on);
    el.classList.toggle('swym-added', on);
    el.setAttribute('aria-pressed', String(on));
    el.setAttribute('aria-label', on ? 'Saved to your wishlist. Tap to remove' : 'Save to wishlist');
  }
  function paintAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(SEL), paint);
    var n = st.items.length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-tsw-count]'), function (c) { c.textContent = n ? String(n) : ''; c.hidden = !n; });
  }
  function enrichProduct(it) {
    if (!it.handle) return;
    fetch('/products/' + encodeURIComponent(it.handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return String(x.id) === String(it.vid); })[0] || p.variants[0] || {};
      var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
      update(it.key, {
        pid: String(p.id), vid: String(v.id || it.vid || ''), title: p.title, image: img ? String(img).replace(/^\/\//, 'https://') : '',
        sub: v.title && v.title !== 'Default Title' ? v.title : '', price: v.price != null ? v.price : p.price,
        url: '/products/' + p.handle + (v.id ? '?variant=' + v.id : '')
      });
      subs.forEach(function (f) { try { f(st.items); } catch (e) {} });
    }).catch(function () {});
  }
  function toggle(el) {
    var it = itemOf(el); if (!it || !it.key) return;
    if (has(it.key)) { remove(it.key); toast('Removed from your wishlist'); return; }
    // on the product's own page, save the variant the shopper has picked
    if (it.kind === 'product' && it.handle && location.pathname.indexOf('/products/' + it.handle) > -1) {
      var box = el.closest('section, form, [data-section-id]') || document;
      var idEl = box.querySelector('[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var pv = (idEl && idEl.value) || new URLSearchParams(location.search).get('variant'); if (pv) it.vid = String(pv);
    }
    add(it);
    if (it.kind === 'product' && (!it.title || !it.price)) enrichProduct(it);
    toast('Saved to your wishlist', true);
    el.classList.add('tsw-pop'); setTimeout(function () { el.classList.remove('tsw-pop'); }, 400);
  }
  // capture phase: runs before card links, the builder's grid handler and any leftover Swym script
  function onHeart(e) {
    var el = e.target.closest && e.target.closest(SEL);
    if (!el) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    if (e.type === 'keydown' && el.tagName === 'BUTTON') return; // buttons fire click on Enter/Space
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    toggle(el);
  }
  document.addEventListener('click', onHeart, true);
  document.addEventListener('keydown', onHeart, true);
  // cards added later (filters, infinite scroll, the builders' grids)
  var moTick = false;
  new MutationObserver(function () { if (moTick) return; moTick = true; requestAnimationFrame(function () { moTick = false; paintAll(); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === LS) { st = read(); if (!Array.isArray(st.items)) st.items = []; paintAll(); subs.forEach(function (f) { f(st.items); }); } });

  /* ---------- toast ---------- */
  var tEl = null, tTimer = null;
  function toast(msg, link) {
    if (!tEl) { tEl = document.createElement('div'); tEl.className = 'tsw-toast'; tEl.setAttribute('role', 'status'); tEl.setAttribute('aria-live', 'polite'); document.body.appendChild(tEl); }
    tEl.innerHTML = '<span>' + esc(msg) + '</span>' + (link && location.pathname !== PAGE ? '<a href="' + esc(PAGE) + '">View wishlist</a>' : '');
    tEl.classList.add('is-on'); clearTimeout(tTimer); tTimer = setTimeout(function () { tEl.classList.remove('is-on'); }, 3200);
  }

  window.TSW = {
    items: function () { return st.items.slice(); }, has: has, add: add, remove: remove, update: update, find: find,
    on: function (f) { subs.push(f); }, paint: paintAll, ready: ready, sync: sync, page: PAGE, api: API, cust: CUST,
    state: function () { return st; },
    share: function () { return (st.share ? Promise.resolve() : sync()).then(function () { return st.share || null; }); },
    email: function (email) {
      st.email = email; write();
      var k = window.klaviyo || window._learnq;
      if (k && k.push) try { k.push(['identify', { $email: email }]); } catch (e) {}
      return (st.token ? Promise.resolve() : sync()).then(function () { return st.token ? post({ op: 'email', token: st.token, email: email }) : null; });
    },
    toast: toast, money: money, esc: esc, abs: abs
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paintAll(); }); else paintAll();
})();
